export const AppConstants = {
    PAYMENT_METHOD: {
        UNDEFINED: 0,
        CREDIT_CARD: 1,
        PIX: 2,
        BOLETO: 3,
        DEBIT_CARD: 4,
    }
};
